import React from "react";
import { Toggle } from "../shared";

const TOKENS = [
  { id: "native", name: "Native currency", symbol: "ETH/BNB/MATIC" },
  { id: "usdc", name: "USDC", symbol: "USDC" },
  { id: "usdt", name: "USDT", symbol: "USDT" },
  { id: "dai", name: "DAI", symbol: "DAI" },
];

export default function TokenAllowlist({
  mode,
  allowedTokens,
  onModeChange,
  onToggleToken,
  disabled,
}) {
  return (
    <div className={`mcp-token-allowlist ${disabled ? "mcp-disabled-section" : ""}`}>
      <h5 className="mcp-subsection-title">Allowed tokens</h5>

      {/* Mode switcher */}
      <div className="mcp-mode-switcher">
        <button
          type="button"
          className={`mcp-mode-btn ${mode === "allowlist" ? "mcp-mode-active" : ""}`}
          onClick={() => onModeChange("allowlist")}
          disabled={disabled}
        >
          Allowlist
        </button>
        <button
          type="button"
          className={`mcp-mode-btn ${mode === "allow_any" ? "mcp-mode-active" : ""}`}
          onClick={() => onModeChange("allow_any")}
          disabled={disabled}
        >
          Allow any
        </button>
      </div>

      {mode === "allow_any" && (
        <div className="mcp-warning-box">
          Allowing any token means the AI agent can interact with any ERC-20
          token, including potentially unknown or risky tokens.
        </div>
      )}

      {mode === "allowlist" && (
        <div className="mcp-token-list">
          {TOKENS.map((token) => (
            <div key={token.id} className="mcp-token-item">
              <div className="mcp-token-info">
                <span className="mcp-token-name">{token.name}</span>
                <span className="mcp-token-symbol">{token.symbol}</span>
              </div>
              <Toggle
                checked={allowedTokens?.includes(token.id)}
                onChange={() => onToggleToken(token.id)}
                disabled={disabled}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
